module.exports = __webpack_public_path__ + "public/img/camerTip.a27ad681.png";